<template>
  <div class="c-dashboard__card">
    <b-card :title="$t('lang.label_certificate_byIssued')" class="text-center">
      <horizontal-bar-chart :style="styles" :chart-data="horizontalChartData" :options="horizontalChartOptions" />
    </b-card>
  </div>
</template>
<script>
import HorizontalBarChart from "../HorizontalBarChart";
export default {
  name: "IssuedCertificatesChart",
  props: {
    statistics: {}
  },
  data() {
    return {
      horizontalChartOptions: {
        responsive: true,
        legend: {
          display: true
        },
        maintainAspectRatio: false,
        scales: {
          xAxes: [
            {
              stacked: true,
              ticks: {
                min: 0,
                max: this.$props.statistics.data.certsIssued.max
              }
            }
          ],
          yAxes: [
            {
              stacked: true
            }
          ]
        }
      },
      //customize height and weight
      styles: {
        width: "100%",
        height: "250px"
      }
    };
  },
  components: {
    HorizontalBarChart
  },
  computed: {
    horizontalChartData() {
      const chartData = {};
      const certsIssued = this.$props.statistics.data.certsIssued;
      const issuedCerts = certsIssued.issued;
      const restCerts = certsIssued.max - issuedCerts;
      var labels = ["Certificates"];
      chartData.datasets = [];
      let issuedData = [
        {
          label: "Issued Certificates",
          backgroundColor: "#0F4C81",
          data: [issuedCerts],
          barPercentage: 0.5
        },
        {
          label: "Remaining Certificates",
          backgroundColor: "#E2E1E4",
          data: [restCerts],
          barPercentage: 0.5
        }
      ];

      Object.keys(issuedData).forEach(data => {
        chartData.datasets.push(issuedData[data]);
      });

      chartData.labels = labels;
      return chartData;
    }
  }
};
</script>
